export default __webpack_public_path__ + "static/media/glasses3.67c5433f.jpeg";